import React, { useEffect, useState } from "react";
import "./hero.css";
import { Link } from "react-router";
import heroImg from '../../Media/Photos Gallery/gal12.png';
import heroImg1 from '../../Media/wardrobe1.jpg';
import heroImg2 from '../../Media/wardrobe2.jpg';
import LogoHero from "../../Media/logohero.png"


const heroImages = [
  heroImg1,
  heroImg2,
  heroImg,
];

export default function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000); 
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero">
      <div className="hero-left">
        <h6 className="small-header">Welcome to Zakarry</h6>
        <h1>Crafting Visions, One step at a Time.</h1>
        <p>
          Zakarry is a women-led fashion brand born from raw passion,
          sisterhood, and the pursuit of excellence. What began as a young
          woman’s love for design evolved into a vision; nurtured by
          consistency, creativity, and a belief in what was possible, even
          without all the resources in place.
        </p>
        <div className="hero-btns">
          <Link to="/about">
            <button className="hero-btn2">EXPLORE MORE</button>
          </Link>
          <Link to="/booking">
            <button className="hero-btn1">BOOK APPOINTMENT</button>
          </Link>
        </div>
      </div>
      <div className="hero-right">
        <div className="hero-img-container">
          {heroImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`hero ${index}`}
              className={`hero-img fade-img ${
                index === currentImageIndex ? "active" : ""
              }`}
            />
          ))}
        </div>
      </div>
      <img
        className="logo-img"
        src={LogoHero}
        alt="logo image"
      />
    </div>
  );
}
